import React, { useEffect } from "react";
import Spinner from "../../custom_components/Spinner/Spinner";
import { withAuthentication } from "@/hoc/withAuthentication";
import { warningAlert } from "@/utility/helpers";
import { withRouter } from "react-router";
import { PENDING_SMS_BUNDLE_KEY } from "@/constants/subscription";

const Processing = ({ match, httpClient, history, user }) => {
  const id = match.params.id;
  const params = new URLSearchParams(history.location.search);
  const subscription_id = params.get("subscription_id") || "";


  useEffect(() => {
    const requestParams = new URLSearchParams();
    requestParams.set("shop",user.selectedShop)
    params.has("ba_token") && requestParams.set("ba_token",params.get("ba_token"))

    //for checkout payment
    params.has("token") && requestParams.set("token",params.get("token"))
    params.has("PayerID") && requestParams.set("payerId",params.get("PayerID"))

    if (id == "success") {
      const confirmSubscription = (isRetry) => {
        httpClient
          .post(`/checkout/successful/${subscription_id}?${requestParams.toString()}`)
          .then((res) => {
            console.log(res);
            warningAlert({ message: "Payment successful.", status: "success" });
            setTimeout(() => {
              window.location.href = "/pricing";
            }, 2000);
          })
          .catch((err) => {
            console.log(err);
            // The confirm call is serialized behind the same per-shop checkout
            // lock as checkout start (repairspotsapi's checkoutLock.js) — a 409
            // here just means another confirm/checkout for this shop was still
            // in flight. It clears in well under a second, so one short retry
            // resolves it without bothering the user.
            if (!isRetry && err?.response?.status === 409 && err?.response?.data?.error === "checkout_in_progress") {
              setTimeout(() => confirmSubscription(true), 1500);
              return;
            }
            // warningAlert({ message: "Payment failed.", status: "danger" });
            setTimeout(() => {
              window.location.href = "/pricing";
            }, 2000);
          });
      };
      confirmSubscription(false);
    }

    if (id == "cancel") {
      warningAlert({ message: "Payment Cancelled.", status: "danger" });
      history.push("/pricing");
    }

    if (id === "sms-success") {
      const orderId = params.get("token");
      const bundleId = sessionStorage.getItem(PENDING_SMS_BUNDLE_KEY);

      if (!orderId || !bundleId) {
        warningAlert({ message: "Missing payment details. Please contact support if you were charged.", status: "danger" });
        setTimeout(() => { window.location.href = "/subscription"; }, 2000);
        return;
      }

      const confirmPurchase = (isRetry) => {
        httpClient
          .post(`/subscriptions/sms-checkout/confirm/${user.selectedShop}`, { orderId, bundleId })
          .then((res) => {
            sessionStorage.removeItem(PENDING_SMS_BUNDLE_KEY);
            warningAlert({ message: `${res.credits} SMS credits added!`, status: "success" });
            setTimeout(() => { window.location.href = "/subscription"; }, 2000);
          })
          .catch((err) => {
            if (!isRetry && err?.response?.status === 409) {
              setTimeout(() => confirmPurchase(true), 1000);
              return;
            }
            sessionStorage.removeItem(PENDING_SMS_BUNDLE_KEY);
            warningAlert({ message: "Payment failed. Please contact support.", status: "danger" });
            setTimeout(() => { window.location.href = "/subscription"; }, 2000);
          });
      };

      confirmPurchase(false);
    }

    if (id === "sms-cancel") {
      sessionStorage.removeItem(PENDING_SMS_BUNDLE_KEY);
      warningAlert({ message: "Payment Cancelled.", status: "danger" });
      setTimeout(() => { window.location.href = "/subscription"; }, 1500);
    }
  }, [id]);

  return (
    <Spinner>
      <div className="uk-light">{id || "Redirecting to payment gateway."}</div>
      <div className="uk-light uk-text-bold">Do not close this window</div>
    </Spinner>
  );
};

export default withRouter(withAuthentication(Processing));
